<script setup lang="ts">
// Photo inside a landing mock, filling its (relative) parent. Photos live in
// public/home/mock, built by docs/marketing/home-mocks/build.py. Most have a
// light and a dark version: both are lazy and the inactive one is display:none,
// so a visitor only downloads the active colour mode's photo. `single` photos
// (avatars) are the same in both modes.
withDefaults(defineProps<{
  name: string
  single?: boolean
  /** CSS object-position */
  position?: string
}>(), { single: false, position: '50% 50%' })
</script>

<template>
  <span class="absolute inset-0">
    <img
      v-if="single"
      :src="`/home/mock/${name}.webp`"
      alt=""
      loading="lazy"
      decoding="async"
      class="block size-full object-cover"
      :style="{ objectPosition: position }"
    >
    <template v-else>
      <img
        :src="`/home/mock/${name}-light.webp`"
        alt=""
        loading="lazy"
        decoding="async"
        class="mock-photo-light block size-full object-cover"
        :style="{ objectPosition: position }"
      >
      <img
        :src="`/home/mock/${name}-dark.webp`"
        alt=""
        loading="lazy"
        decoding="async"
        class="mock-photo-dark size-full object-cover"
        :style="{ objectPosition: position }"
      >
    </template>
  </span>
</template>

<style scoped>
.mock-photo-dark,
.dark .mock-photo-light {
  display: none;
}

.dark .mock-photo-dark {
  display: block;
}
</style>
